/**
 * Media domain types. FROZEN after WS-0. Do not redefine locally.
 */
import { z } from 'zod';
export const MediaStatusSchema = z.enum(['pending', 'transcoding', 'ready', 'failed']);
export const AudioTrackInfoSchema = z.object({
    id: z.string(),
    label: z.string(),
    language: z.string(),
    kind: z.enum(['main', 'alternative', 'commentary', 'descriptions']),
    channels: z.number().int().nonnegative(),
});
export const SubtitleTrackInfoSchema = z.object({
    id: z.string(),
    label: z.string(),
    language: z.string(),
    forced: z.boolean(),
    playlistUrl: z.string(),
});
export const RenditionInfoSchema = z.object({
    id: z.string(),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    bandwidth: z.number().int().positive(),
});
export const MediaSummarySchema = z.object({
    id: z.string(),
    title: z.string(),
    durationSec: z.number().nonnegative(),
    status: MediaStatusSchema,
    posterUrl: z.string().nullable(),
});
export const MediaDetailSchema = MediaSummarySchema.extend({
    manifestUrl: z.string(),
    renditions: z.array(RenditionInfoSchema),
    audioTracks: z.array(AudioTrackInfoSchema),
    subtitleTracks: z.array(SubtitleTrackInfoSchema),
    failureReason: z.string().nullable(),
});
export const JobStatusSchema = z.enum(['queued', 'running', 'completed', 'failed', 'cancelled']);
export const TranscodeJobSchema = z.object({
    id: z.string(),
    mediaId: z.string(),
    status: JobStatusSchema,
    progress: z.number().min(0).max(1),
    stage: z.string().nullable(),
    error: z.string().nullable(),
    startedAt: z.number().int().nullable(),
    finishedAt: z.number().int().nullable(),
    createdAt: z.number().int(),
});
//# sourceMappingURL=media.js.map